import { Background } from '@do/walrus';
import React, { ReactElement } from 'react';
import {
  VariantBackgroundColor,
  VariantBackgroundImage,
  VariantProps
} from '../interfaces/variant';
import { Column, Row } from './Common';
import { Splash } from './Splash';

interface Props {
  variant: VariantProps;
}

export const Variant: React.FC<Props> = ({
  children,
  variant
}): ReactElement => {
  return variant?.splash ? (
    <Row>
      <Column
        style={{
          background: (variant?.background as VariantBackgroundColor)?.color
            ? (variant.background as VariantBackgroundColor).color
            : 'unset'
        }}
      >
        {children}
      </Column>
      <Splash splash={variant.splash} />
    </Row>
  ) : (
    <>
      <Background
        url={(variant.background as VariantBackgroundImage).image}
        horizontalPosition={
          (variant.background as VariantBackgroundImage).horizontalPosition
        }
        verticalPosition={
          (variant.background as VariantBackgroundImage).verticalPosition
        }
      />
      {children}
    </>
  );
};
